import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-delete-ticket-type',
  templateUrl: './delete-ticket-type.component.html',
  styleUrls: ['./delete-ticket-type.component.css']
})
export class DeleteTicketTypeComponent implements OnInit {

  data: any;

  modelSubtitle = false

 tickets:any = []
 checked = false

 name = ""
 version = ""
 isActive = false
i: any;
deleteId: any = "";


 constructor(private toastr: ToastrService,private generic_service: GenericService) { }

ngOnInit(): void {
  this.getalltickets()
 
}

 

cancelModel(){
  document.getElementById("closeModalButton")?.click()
  document.getElementById("closeModalButton1")?.click()
}

getalltickets(){
  this.generic_service.getAllTickets().subscribe(
    (response:any)=>{
      this.tickets = response.response;
      console.log(response)
    }
  )
} 

deleleTicketType(){
   this.generic_service.deleteTicketType(this.deleteId).subscribe(
    (res:any)=>{
      this.toastr.success("Successfully Deleted");
      this.getalltickets();
      this.cancelModel();
    },err=>{
      this.toastr.error(err.errors[0].description);
    }
    
    
   )
}

del(id:any){
  this.deleteId = id
}

}